import { formatNumberAndRevision } from "../../../../utils/formatNumberAndRevision";
import { getDisplayFileName } from "../../../../functions/helperMethod";

export const getTemplateDetailFields = (template) => {
  if (!template) {
    return {
      documentNo: "-",
      docClass: "-",
      format: "-",
      title: "-",
    };
  }

  const documentNo = formatNumberAndRevision(template.DocNo, template.DocRev);
  const docClass =
    template.DocClassAndDocName ||
    (template.DocClass ? String(template.DocClass).trim() : "") ||
    "-";
  const format = template.Format?.trim() || "-";
  const title = getDisplayFileName(template.Title ?? "") || "-";

  return {
    documentNo: documentNo || "-",
    docClass,
    format,
    title,
  };
};

const getTemplateLanguageDisplay = (template) => {
  const language = template?.Language ?? template?.language;
  if (language) return String(language).trim();

  const code = template?.LanguageCode ?? template?.languageCode;
  if (code) return String(code).trim();

  return "-";
};

export const getTemplateTooltipContent = (template) => {
  if (!template) return [];

  const { documentNo, docClass, format, title } = getTemplateDetailFields(template);
  const language = getTemplateLanguageDisplay(template);

  return [
    `Title: ${title}`,
    `Document No: ${documentNo}`,
    `Class: ${docClass}`,
    `Format: ${format}`,
    `Language: ${language}`,
  ];
};


